module.exports = __webpack_public_path__ + "static/media/PalletImg.43377cf0.png";